import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LoaderButton } from 'ctia-ui';
import ResultPanel from 'components/ResultPanel';
import PublicationOption from 'components/PublicationOption';
import PageHeader from 'components/request/RequestPageHeader';
import { getUrlRequestPrefix } from 'helpers/Users';
import {
  updatePublicationOptions,
  returnToEditRequest,
  fetchRequest,
  updateRequest
} from 'actions/request';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { fetchRequestTests, fetchTestReports } from 'actions/tests';
import requestTypes from 'dictionaries/ReqTypes';

class RequestResultPage extends Component {
  constructor(props) {
    super(props);

    this.urlPrefix = getUrlRequestPrefix(props.user);
    this.redirectUrl = `${this.urlPrefix}/requests`;
  }
  onDoneClick = () => {
    const { request, startPreloader, updatePublicationOptions } = this.props;

    // we don't need to change publication options for ECO
    if (request.type === requestTypes.eco) {
      this.updateCallback();
    } else {
      const { newId, id, certificationOption } = request;
      const reqId = newId || id;
      const reqData = { id: reqId, certificationOption };

      startPreloader();
      updatePublicationOptions(reqData, this.updateCallback);
    }
  };

  updateCallback = () => {
    const { history, finishPreloader } = this.props;
    finishPreloader();
    history.push(this.redirectUrl);
  };

  backToEdit = () => {
    const {
      fetchRequest,
      returnToEditRequest,
      request,
      history,
      startPreloader,
      finishPreloader,
      updateRequest,
      fetchRequestTests,
      fetchTestReports
    } = this.props;

    startPreloader();

    // if it is just submitted, then simple redirect
    if (request.newId) {
      updateRequest({ id: request.newId });
      finishPreloader();
      history.push(`${this.redirectUrl}/${request.newId}`);
    } else {
      // reset `show results` mode
      returnToEditRequest();

      // fetch new request data
      fetchRequest(request.id)
        .then(() => fetchRequestTests(request.id))
        .then(res => {
          const testId = res.payload.data.data[0].id;
          return fetchTestReports(testId);
        })
        .then(finishPreloader);
    }
  };

  render() {
    const { isInitial, isSubmit, isUpdate, isSave } = this.props;

    return (
      <div>
        <PageHeader />
        <ResultPanel isSubmit={isSubmit} isUpdate={isUpdate} isSave={isSave} />
        {isInitial && isSubmit && <PublicationOption />}
        <LoaderButton text="&larr; Return to Edit" onClick={this.backToEdit} />
        <LoaderButton
          text="Done"
          onClick={this.onDoneClick}
          bsStyle="success"
          style={{ marginLeft: 10 }}
        />
      </div>
    );
  }
}

RequestResultPage.propTypes = {
  isInitial: PropTypes.bool,
  isEco: PropTypes.bool,
  isSubmit: PropTypes.bool,
  isUpdate: PropTypes.bool,
  isSave: PropTypes.bool
};

RequestResultPage.defaultProps = {
  isInitial: false,
  isEco: false,
  isSubmit: false,
  isUpdate: false,
  isSave: false
};

function mapStateToProps({ user, request }) {
  return { user, request };
}

export default connect(
  mapStateToProps,
  {
    startPreloader,
    finishPreloader,
    updatePublicationOptions,
    returnToEditRequest,
    fetchRequest,
    updateRequest,
    fetchRequestTests,
    fetchTestReports
  }
)(RequestResultPage);



// WEBPACK FOOTER //
// ./src/components/request/RequestResultPage.js